module.exports = "/static/images/ljea-logo.png";